import { InputSelect } from './InputSelect.component';

export default InputSelect;
